import React from "react";

const CardMeeting = ({ data, ...props }) => {
  return (
    <a
      className="group border border-ideaListGrey100 rounded-md p-4 sm:p-8"
      href={data.permalink}
    >
      {data.date && (
        <div class="text-ideaBlue100 font-bold mb-2">{data.date}</div>
      )}
      {data.location && (
        <div class="content-card--location text-mobileXS md:text-desktopXS text-ideaTextBlack100/80 mb-2">
          {data.location}
        </div>
      )}
      <div class="text-mobileS md:text-desktopS font-bold transition-all duration-200 group-hover:text-ideaBlue100">
        {data.title}
      </div>
    </a>
  );
};

export default CardMeeting;
